$(document).on('turbolinks:load', function () {
  function toggleMenu() {
    $(".open-btn").toggleClass('active');
    $("#g-nav").toggleClass('panel-active');
    $("#hamburger-menu-bg").toggleClass('active');
    $("body, html").toggleClass('no-scroll');
  }

  function closeMenu() {
    $(".open-btn").removeClass('active');
    $("#g-nav").removeClass('panel-active');
    $("#hamburger-menu-bg").removeClass('active');
    $("body, html").removeClass('no-scroll');
  }

  $(".open-btn").on('click', toggleMenu);
  $("#hamburger-menu-bg").on('click', toggleMenu);

  // Turbolinksページ遷移時に状態リセット
  $(document).on('turbolinks:before-visit', function () {
    closeMenu();
  });
});
